module.exports = __webpack_public_path__ + "static/img/video.387d350.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index/video.png
// module id = 7iqc
// module chunks = 7